(function () {
  function init() {
  const wrapperSelector = '.product__media-wrapper';
  const formSelector = '#tee-artwork-form, tee-artwork-form';
  const mobileQuery = window.matchMedia('(max-width: 767px), (pointer: coarse)');
  const styleId = 'tee-sticky-gallery-mobile-styles';
  const paddingY = 12;
  const nativeGallerySelector = 'media-gallery, [id^="MediaGallery-"]';

  let stickyWrapper = null;
  let originalWrapperHeight = 0;
  let closeButton = null;
  let reopenButton = null;
  let pendingFrame = 0;
  let focusScrollTimer = 0;
  let anchorAdjusted = false;

  function findGallery(wrapper) {
    return wrapper.querySelector('.tee-gallery-content') ||
      wrapper.querySelector('#tee-gallery') ||
      wrapper.querySelector(nativeGallerySelector);
  }

  function ensureStyles() {
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' { z-index: 1000; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' #tee-gallery { background:#fff; box-shadow:0 2px 12px rgba(0,0,0,.18); box-sizing:border-box; display:block !important; height:calc(var(--tee-sticky-size,300px) + 12px) !important; left:0; overflow:hidden; padding:6px 0; position:fixed; right:0; top:0; transform:none !important; width:100vw !important; z-index:1000; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' #tee-gallery > .tee-gallery { margin-left:calc((100vw - var(--tee-sticky-size,300px))/2); transform:scale(var(--tee-sticky-scale,.86)); transform-origin:top left; width:max-content; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .tee-gallery { width:auto; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .tee-thumbnails, body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .tee-slider__dots { display:none !important; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' media-gallery, body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' [id^="MediaGallery-"] { background:#fff; box-shadow:0 2px 8px rgba(0,0,0,.16); box-sizing:border-box; display:block; height:44vh !important; left:0; max-height:44vh; overflow:hidden; padding-top:env(safe-area-inset-top); position:fixed; top:0; width:100vw; z-index:1000; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' media-gallery slider-component:not(.thumbnail-slider), body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' [id^="MediaGallery-"] slider-component:not(.thumbnail-slider) { height:100%; max-height:100%; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .product__media-list { align-items:center; height:100% !important; max-height:100%; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .product__media-item { height:100% !important; max-height:100%; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .product__media { height:100% !important; padding-bottom:0 !important; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .product__media img { height:100% !important; max-height:100% !important; object-fit:contain !important; width:100% !important; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .thumbnail-slider, body.gallery--sticky:not(.gallery--sticky--hide) ' + wrapperSelector + ' .thumbnail-list { display:none !important; }',
      'body.gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button { align-items:center; background:#fff; border:0; border-radius:50%; box-shadow:0 2px 8px rgba(0,0,0,.2); color:#333; display:grid; height:28px; place-items:center; position:fixed; right:6px; top:calc(6px + env(safe-area-inset-top)); width:28px; z-index:1002; }',
      'body.gallery--sticky.gallery--sticky--hide .sticky-gallery-button { background:#5d1010; border:0; border-radius:24px; bottom:max(16px, env(safe-area-inset-bottom)); color:#fff; display:block; padding:13px 18px; position:fixed; right:16px; z-index:1002; }',
      '#tee-artwork-form, tee-artwork-form, #tee-artwork-form input, tee-artwork-form input, #tee-artwork-form textarea, tee-artwork-form textarea { scroll-margin-top:min(44vh, 340px); }',
      'body.gallery--dialog-open ' + wrapperSelector + ' #tee-gallery { visibility:hidden !important; pointer-events:none !important; }',
      'body.gallery--dialog-open .gallery--close-button, body.gallery--dialog-open .sticky-gallery-button { display:none !important; }',
      'body.gallery--dialog-open .tee-dialog-gallery .vm--overlay { background:#fff !important; opacity:1 !important; }',
      '.gallery--close-button, .sticky-gallery-button { cursor:pointer; display:none; font:600 14px/1 system-ui,sans-serif; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function ensureControls() {
    if (!closeButton || !closeButton.isConnected) {
      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'gallery--close-button';
      closeButton.setAttribute('aria-label', 'Masquer l’aperçu');
      closeButton.textContent = 'x';
      closeButton.addEventListener('click', function () {
        document.body.classList.add('gallery--sticky--hide');
      });
      document.body.appendChild(closeButton);
    }
    if (!reopenButton || !reopenButton.isConnected) {
      reopenButton = document.createElement('button');
      reopenButton.type = 'button';
      reopenButton.className = 'sticky-gallery-button';
      reopenButton.textContent = 'Voir l’affiche';
      reopenButton.addEventListener('click', function () {
        document.body.classList.remove('gallery--sticky--hide');
        scheduleUpdate();
      });
      document.body.appendChild(reopenButton);
    }
  }

  function syncPreviewSize(wrapper) {
    const slider = wrapper.querySelector('#tee-gallery .tee-slider');
    const baseWidth = slider ? slider.offsetWidth : wrapper.clientWidth;
    const activeField = document.activeElement;
        const form = document.querySelector(formSelector);
            const currentSize = parseFloat(wrapper.style.getPropertyValue('--tee-sticky-size'));
                const isTyping = form && form.contains(activeField) && activeField.matches('input[type="text"], input:not([type]), textarea');
                    const size = isTyping && currentSize ? currentSize : Math.round(Math.min(320, window.innerWidth - 24, Math.max(220, window.innerHeight * 0.42)));
    const scale = Math.min(1, size / (baseWidth || 348)).toFixed(4);
    if (wrapper.style.getPropertyValue('--tee-sticky-size') !== size + 'px') wrapper.style.setProperty('--tee-sticky-size', size + 'px');
    if (wrapper.style.getPropertyValue('--tee-sticky-scale') !== scale) wrapper.style.setProperty('--tee-sticky-scale', scale);
  }

  function clearSticky() {
    document.body.classList.remove('gallery--sticky', 'gallery--sticky--hide');
    if (stickyWrapper) {
      stickyWrapper.style.removeProperty('height');
      stickyWrapper.style.removeProperty('--tee-sticky-size');
      stickyWrapper.style.removeProperty('--tee-sticky-scale');
    }
    stickyWrapper = null;
    originalWrapperHeight = 0;
  }

  function activateSticky(wrapper) {
    ensureStyles();
    ensureControls();
    stickyWrapper = wrapper;
    originalWrapperHeight = Math.ceil(wrapper.getBoundingClientRect().height);
    wrapper.style.height = originalWrapperHeight + 'px';
    wrapper.style.display = 'block';
    syncPreviewSize(wrapper);
    document.body.classList.add('gallery--sticky');
    adjustAnchor(wrapper, document.querySelector(formSelector));
  }

  function adjustAnchor(wrapper, form) {
    if (!form || anchorAdjusted || window.location.hash !== '#tee-artwork-form') return;
    const panelHeight = parseFloat(wrapper.style.getPropertyValue('--tee-sticky-size')) + 12;
    const overlayHeight = Math.min(320, window.innerWidth - 24, Math.max(220, window.innerHeight * 0.42)) + 12;
      const formTop = form.getBoundingClientRect().top;
    if (formTop < panelHeight + 16) {
      anchorAdjusted = true;
      window.scrollBy(0, formTop - panelHeight - 16);
    }
  }

  function updateSticky() {
    const dialogOpen = !!document.querySelector('.teeinblue-item .vm--modal[role="dialog"][aria-expanded="true"]');
    document.body.classList.toggle('gallery--dialog-open', dialogOpen);
    if (!mobileQuery.matches) {
      clearSticky();
      return;
    }

    const wrapper = document.querySelector(wrapperSelector);
    const form = document.querySelector(formSelector);
    if (!wrapper || !form) {
      if (stickyWrapper) clearSticky();
      return;
    }

    if (stickyWrapper && stickyWrapper !== wrapper) clearSticky();
    const galleryRect = wrapper.getBoundingClientRect();
    const formBottom = form.getBoundingClientRect().bottom;
    const overlayHeight = Math.min(320, window.innerWidth - 24, Math.max(220, window.innerHeight * 0.42)) + 12;
    const formTop = form.getBoundingClientRect().top;
    const sticky = document.body.classList.contains('gallery--sticky');
    if (sticky) {
      syncPreviewSize(wrapper);
      adjustAnchor(wrapper, form);
    }

    if (sticky && (galleryRect.top >= 0 || formTop >= window.innerHeight - 20 || formBottom <= overlayHeight)) {
      clearSticky();
    } else if (!sticky && galleryRect.top < -80 && formTop < window.innerHeight - 20 && formBottom > overlayHeight) {
      activateSticky(wrapper);
    }
  }

  function alignFocusedField() {
    if (!mobileQuery.matches || document.body.classList.contains('gallery--sticky--hide') || document.body.classList.contains('gallery--dialog-open')) return;
    const form = document.querySelector(formSelector);
    const field = document.activeElement;
    if (!form || !field || !form.contains(field) || !field.matches('input[type="text"], input:not([type]), textarea')) return;
    const gallery = document.querySelector('#tee-gallery');
    if (!gallery || !document.body.classList.contains('gallery--sticky')) return;
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const minTop = gallery.getBoundingClientRect().bottom + 12;
    const maxBottom = viewportHeight - 110;
    const rect = field.getBoundingClientRect();
    if (maxBottom - minTop < rect.height + 8) return;
    if (rect.top < minTop) window.scrollBy(0, rect.top - minTop);
    else if (rect.bottom > maxBottom) window.scrollBy(0, rect.bottom - maxBottom);
  }

  function scheduleFocusedFieldAlignment() {
    window.clearTimeout(focusScrollTimer);
    focusScrollTimer = window.setTimeout(alignFocusedField, 120);
  }

  function scheduleUpdate() {
    if (pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(function () {
      pendingFrame = 0;
      updateSticky();
    });
  }

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('hashchange', scheduleUpdate);
  window.addEventListener('resize', function () { scheduleUpdate(); scheduleFocusedFieldAlignment(); }, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { scheduleUpdate(); scheduleFocusedFieldAlignment(); }, { passive: true });
  document.addEventListener('focusin', scheduleFocusedFieldAlignment);
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href*="#tee-artwork-form"]');
    if (link) anchorAdjusted = false;
  });
  ['input', 'change', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!(event.target instanceof Element)) return;
      const inWidget = event.target.closest('.teeinblue-item');
      const inForm = event.target.closest(formSelector);
      if (!inWidget && !inForm) return;
      scheduleUpdate();
      if (inWidget && mobileQuery.matches && !document.body.classList.contains('gallery--sticky')) {
        const wrapper = document.querySelector(wrapperSelector);
        const form = document.querySelector(formSelector);
        if (!wrapper || !form) return;
        const bounds = form.getBoundingClientRect();
        const overlayHeight = Math.min(320, window.innerWidth - 24, Math.max(220, window.innerHeight * 0.42)) + 12;
        if (bounds.top < window.innerHeight - 20 && bounds.bottom > overlayHeight) activateSticky(wrapper);
      }
    });
  });
  document.addEventListener('shopify:section:load', scheduleUpdate);

  const galleryObserver = new MutationObserver(scheduleUpdate);
  galleryObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  scheduleUpdate();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
